import {
	getDateTimePickerFieldValue,
	getSingleVersionPickerValue,
	getRichTextFieldValue,
	getNumberFieldValue,
	getSingleSelectFieldValue,
	getStringFieldValue,
	getMultipleVersionPickerFieldValue,
	getMultipleSelectFieldValue,
	getLabelsFieldValue,
	getDatePickerFieldValue,
} from './get-field-value';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fieldMap: Record<string, any> = {
	JiraDateTimePickerField: getDateTimePickerFieldValue,
	JiraSingleVersionPickerField: getSingleVersionPickerValue,
	JiraRichTextField: getRichTextFieldValue,
	JiraConnectRichTextField: getRichTextFieldValue,
	JiraUrlField: getStringFieldValue,
	JiraSingleLineTextField: getStringFieldValue,
	JiraConnectTextField: getStringFieldValue,
	JiraNumberField: getNumberFieldValue,
	JiraConnectNumberField: getNumberFieldValue,
	JiraSingleSelectField: getSingleSelectFieldValue,
	JiraRadioSelectField: getSingleSelectFieldValue,
	JiraConnectSingleSelectField: getSingleSelectFieldValue,
	JiraCheckboxesField: getMultipleSelectFieldValue,
	JiraMultipleVersionPickerField: getMultipleVersionPickerFieldValue,
	JiraMultipleSelectField: getMultipleSelectFieldValue,
	JiraConnectMultipleSelectField: getMultipleSelectFieldValue,
	JiraLabelsField: getLabelsFieldValue,
	JiraDatePickerField: getDatePickerFieldValue,
};

export const prefillCustomFieldMap = ({
	gqlType,
	defaultValue,
	allowedValues,
}: {
	gqlType: string;
	defaultValue: unknown;
	allowedValues?: unknown;
}) => {
	if (typeof fieldMap[gqlType] !== 'function') return null;
	if (allowedValues) {
		return fieldMap[gqlType]({ defaultValue, allowedValues });
	}
	return fieldMap[gqlType](defaultValue);
};

export { getCascadingSelectFieldValue } from './get-field-value';

export const getWorkLogFieldValues = (key: unknown, input: unknown) => {
	if (key === 'worklog_timeLogged') {
		return { timeSpent: getStringFieldValue(input) };
	}
	if (key === 'worklog_startDate') {
		return {
			dateValue: getDateTimePickerFieldValue(input),
		};
	}
	if (key === 'worklog_comment') {
		return {
			description: getRichTextFieldValue(input),
		};
	}
	if (key === 'timetracking_remainingestimate') {
		return {
			timeRemaining: getStringFieldValue(input),
		};
	}
};

export const workLogSubFieldTypes: string[] = [
	'worklog_timeLogged',
	'worklog_startDate',
	'worklog_comment',
	'timetracking_remainingestimate',
];
